import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useIsMobile } from '../hooks/useMediaQuery';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

export default function AppShell() {
  const { currentTheme } = useTheme();
  const isMobile = useIsMobile();
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!isMobile) setNavOpen(false);
  }, [isMobile]);

  return (
    <div
      className={`cz-root ${currentTheme === 'light' ? 'lite' : ''}`}
      style={{
        minHeight: '100vh',
        background: 'var(--page-bg)',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        color: 'var(--tx)',
        display: 'flex',
        padding: isMobile ? '16px 14px 28px' : '28px 36px 36px 24px',
        gap: isMobile ? 0 : 26,
      }}
    >
      <Sidebar isMobile={isMobile} open={navOpen} onClose={() => setNavOpen(false)} pathname={location.pathname} />
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 20 }}>
        <TopBar isMobile={isMobile} onOpenNav={() => setNavOpen(true)} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
